import i18next from 'i18next'
import * as React from 'react'

export const CollectionDeleterLayout = {
  Confirmation: (props: { kind: 'component' | 'collection' }) => (
    <>
      {props.kind === 'component'
        ? i18next.t('collection:modalTextDeleteComponentFromCollection')
        : i18next.t('collection:modalTextDeleteCollection')}
    </>
  ),
  Failed: (props: { kind: 'component' | 'collection' }) => (
    <>
      {props.kind === 'collection'
        ? i18next.t('collection:modalTextDeleteCollectionFailed')
        : i18next.t('collection:modalTextSaveDeleteFromCollectionFailed')}
    </>
  ),
}
